export interface OptionChildren {
  _key: string
  _type: string
  marks: unknown[]
  text: string
  body: string
}

export interface Option {
  _key: string
  _type: string
  children: OptionChildren[]
  markDefs: unknown[]
  style: string
}

export interface MultipleChoiceQuestionOption {
  _key: string
  _type: string
  isCorrect?: boolean
  isLast?: boolean
  option: Option[]
}

export interface Question {
  _key: string
  _type: string
  style: string
}

export interface MultipleChoiceQuestion {
  options: MultipleChoiceQuestionOption[]
  question: Question[]
}

export interface MultipleChoiceTestScore {
  _key: string
  points: number
  score: number
}

export interface MultipleChoiceTestData {
  multipleChoiceQuestions: MultipleChoiceQuestion[]
  scoreTable: MultipleChoiceTestScore[]
  trophy: string
  url: string
  taskId: string
}

export interface MultipleChoiceTestActiveQuestion {
  index: number
  didAnswer: boolean
  didAnswerCorrectly: boolean
  selectedOption: MultipleChoiceQuestionOption | null
}

export interface MultipleChoiceTestQuestionsState {
  [key: string]: {
    didAnswer: boolean
    didAnswerCorrectly: boolean
  }
}

export type MultipleChoiceTestEventScore = Array<{
  points: number
  score: number
  stars: number
}>

export enum MULTIPLE_CHOICE_TEST_VIEW {
  QUIZ = 'quiz',
  SUMMARY = 'summary',
}

export enum MULTIPLE_CHOICE_TEST_GRADE {
  FAILED = 'failed',
  PASS = 'pass',
  GOOD = 'good',
  GREAT = 'great',
}
